import { getFormattedDate, getTodayDate, getTomorrowDate } from '@app/utils/date'
import { dateFormat } from '@app/constants'
import { MONITORING_TASK_VALIDATION_CONFIG_NAMES } from '@app/api/constants'

import type { ResponseDto } from '@app/api/dtos'
import type { MonitoringValidationResultsConfigDto } from '@app/api/routes/monitoringValidation/dtos'
import type { CheckingPricesCompetitorsDataSource, LogReportData } from '@app/pages/CheckingPricesCompetitorsPage/types'
import type { TableData } from '@app/types/table'
import type { CommonExportExcelLogReportParams } from '@app/api/routes/monitoringTasks/types'

export const adaptCheckingPricesCompetitorsTableData = (
  monitoringValidationResultsConfigResponse: ResponseDto<MonitoringValidationResultsConfigDto>
): TableData<CheckingPricesCompetitorsDataSource> => {
  const { count, results: monitoringValidationResultsConfig } = monitoringValidationResultsConfigResponse

  const dataSource: CheckingPricesCompetitorsDataSource[] = monitoringValidationResultsConfig.map(dto => ({
    key: dto.name,
    configName: MONITORING_TASK_VALIDATION_CONFIG_NAMES[dto.name] ?? null,
    configValue: dto.value
  }))

  return { count, dataSource }
}

export const adaptCommonExportExcelLogReportParams = (
  logReportData: LogReportData
): CommonExportExcelLogReportParams => {
  const formattedTodayDate = getFormattedDate(getTodayDate(), dateFormat.YYYY_MM_DD) ?? undefined
  const formattedTomorrowDate = getFormattedDate(getTomorrowDate(), dateFormat.YYYY_MM_DD) ?? undefined

  const formattedLogReportFirstPeriodDate = getFormattedDate(logReportData.periodDate[0], dateFormat.YYYY_MM_DD)
  const formattedLogReportSecondPeriodDate = getFormattedDate(logReportData.periodDate[2], dateFormat.YYYY_MM_DD)

  const createdAtAfter = formattedLogReportFirstPeriodDate ?? formattedTodayDate
  const createdAtBefore = formattedLogReportSecondPeriodDate ?? formattedTomorrowDate

  return {
    createdAtAfter,
    createdAtBefore
  }
}
